// extracted by mini-css-extract-plugin
export var content = "_95-3";
export var list = "_95-4";
export var settingsContent = "_95-7";
export var settingsPanel = "_95-8";
export var state = "_95-6";
export var triggerBadge = "_95-2";
export var triggerButton = "_95-1";
export var triggerShell = "_95-0";
export var unreadDot = "_95-5";